import { EventCategory, LocalEventCategory } from '@/types/event';
import { isDev, isLocal } from '@/constant/index';
import { isAvailableDate } from '@/utils/date';

// 홈 좌측 상단 이벤트 배너는 어드민에 등록한 값을 API 로 받아 노출한다(PORTAL-14482).
// 여기 남은 항목은 SideCategory 의 이벤트 카테고리 용도이므로 배너와 함께 지우지 않는다.

// TODO: 노출할 곳도 받을 수 있도록 정하기 ex. HOME은 노출되지만, 카테고리 노출은 안되어야 함
const LocalEventCategories: Map<string, LocalEventCategory> = new Map([
  [
    'quit-smoking',
    {
      title: '금연 캠페인',
      url: '/events/quit-smoking',
      imageUrl: '/images/events/quit-smoking/quit-smoking-banner.jpg',
      startDate: isLocal || isDev ? '2025-08-11' : '2025-08-12',
      endDate: '2025-08-18',

      category: {
        title: '금연 캠페인',
        value: '6875f58febc992abcb0e5a75',
      },
    },
  ],
]);

export const EventCategories: Map<string, EventCategory> = Array.from(
  LocalEventCategories.entries(),
).reduce((previousValue, [key, value]) => {
  const { categoryData, ...others } = value;
  previousValue.set(key, {
    ...others,
    data: categoryData,
    isShow: isAvailableDate(value.startDate, value.endDate),
  });
  return previousValue;
}, new Map() as Map<string, EventCategory>);
